export const ADD_FAVORITES = "ADD_FAVORITES";
export const DELETE_FAVORITES = "DELETE_FAVORITES"
export const DELETE_CHARACTER = 'DELETE_CHARACTER'
export const FILTER = 'FILTER'
export const ORDER = 'ORDER'